import { request, gql } from 'graphql-request';

//HR List
export const fecthResignationTableData =`
query{ 
  allResignationForms{ 
    id 
    employeeName 
    employeeId 
    designation 
    department 
    dateOfResignation 
    reason 
    otherReason 
    noticeOption 
    noticePeriod 
    teamApproval  
    hrApproval  
    waiveNotice 
    doNotWaiveNotice 
    replacementRequired 
    rehireRequired 
    status 
    createdAt 
    user{
      dateOfJoining
    }
  } 
} `;
 
//Team List
export const teamResignationList =`
query GetResignationApprovals($id: ID!) { 

  resignationRequestTeam(id: $id) { 

    success 

    error 

    message 

    data { 

      id 

      employeeName 

      employeeId 

      designation 

      department 

     noticeOption 
    dateOfResignation 

    reason 

    otherReason  

    noticePeriod 

      teamApproval 

      hrApproval 

      teamApprovalDate 

  hrApprovalDate 

waiveNotice 

    doNotWaiveNotice 

    replacementRequired 

    rehireRequired 

      status 

      createdAt 
      user{
        dateOfJoining
      }
    } 

  } 

}`;

//My List
export const myResignationList =`
query allResignationFormsUser($id:ID!){ 

  allResignationFormsUser(userId:$id){ 

    id 

    employeeName 

    employeeId 

    designation 

    department 

    dateOfResignation 

    reason 

    otherReason  

    noticeOption 

    noticePeriod 

    teamApproval 

    hrApproval 

   teamApprovalDate 

  hrApprovalDate  

    waiveNotice 

    doNotWaiveNotice 

    replacementRequired 

    rehireRequired 

    status 

    createdAt 
    user{
        dateOfJoining
    }
  } 

}`;

//Get data by ID
export const getResignationDataById=`
 query getResignationFormById($id:ID!){  

  getResignationFormById(id:$id){  

    id  

    employeeName  

    employeeId  

    designation  

    department  

    dateOfResignation  

    reason  

    otherReason  

   noticeOption 

    noticePeriod  

    teamApproval  

    teamApprovalDate  

    hrApproval  

    hrApprovalDate  

    waiveNotice 

    doNotWaiveNotice 

    replacementRequired 

    rehireRequired 

    status  

    createdAt  

  }  

}`;

//Create Resignation Form
export const createMutationQuery = gql`
mutation createresignationform($input:CreateResignationFormInput!){ 

  createResignationForm(input:$input){ 

    success 

    message 

    error 

  } 

} `;

//Update Resignation Form
export const updateMutationQuery = gql`
mutation updateResignationForm($input: UpdateResignationFormInput!) { 

  updateResignationForm(input: $input) { 

    success 

    message 

    error 

  } 

} `;

export const deleteResignationFormQuery = gql`
mutation deleteresignationform($id:ID!){ 

  deleteResignationForm(id:$id){ 

    success 

    message 

    error 

  } 

}`;